<template>
  <div class="containers">
    <Header></Header>
    <div class="content" v-html="content">
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '../layout/commponents/Footer.vue'
import Header from '../layout/commponents/Header.vue'
import { templatesDetail } from '@/api/index.js'

export default {
  data() {
    return {
      id: null,
      content: ''
    }
  },
  components: {
    Footer,
    Header
  },
  mounted() {
    this.id = this.$route.query.currentRowId
    this.getTemplatesDetail()
  },
  methods: {
    async getTemplatesDetail() {
      await templatesDetail({ id: this.id }).then(res => {
        this.content = res.data.content
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
 width: 100%;
 background-color: #112945;
  // background: linear-gradient(to right, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);

 padding-top: 100px;
 height: 100vw;
}
</style>
